
    <div class="modal__head"><ng-content></ng-content></div>
  


// WEBPACK FOOTER //
// ./src/app/@compartidos/components/modal/modal-head.component.ts.ModalHeadComponent.html